import { api } from '@/lib/api/client'
import type { Article } from '@/modules/news/model/types'

export interface AdminArticleDTO extends Article {
  content?: string
  status: 'draft' | 'published' | 'DRAFT' | 'PUBLISHED'
}
export interface Paged<T> { items: T[]; total: number; page: number; pageSize: number }

export const articlesApi = {
  listPublic: (q: { page?: number; pageSize?: number; category?: string; q?: string } = {}) =>
    api.get<Paged<Article>>('/articles', { params: q }),
  one: (slug: string) => api.get<Article>(`/articles/${slug}`),
  adminList:   (q: { page?: number; pageSize?: number; status?: string } = {}) =>
    api.get<Paged<AdminArticleDTO>>('/admin/articles', { params: q }),
  adminOne:    (id: string) => api.get<AdminArticleDTO>(`/admin/articles/${id}`),
  adminCreate: (p: Omit<AdminArticleDTO, 'id'>) => api.post<AdminArticleDTO>('/admin/articles', p),
  adminUpdate: (id: string, p: Partial<AdminArticleDTO>) => api.patch<AdminArticleDTO>(`/admin/articles/${id}`, p),
  adminDelete: (id: string) => api.delete<void>(`/admin/articles/${id}`),
}
